import React from "react";

/**
 * Hero block: optional eyebrow, big headline (with one italic gradient word),
 * supporting subtext. The headline string is rendered as-is — to get the
 * gradient effect on a specific word, the API can wrap it in `*…*` markers
 * which we render inline as a span. This keeps the markup data-driven without
 * needing a full markdown renderer.
 *
 * @param {{ section?: import('../../../../types/corporate').HeroSection }} props
 */
const Hero = ({ section }) => {
  if (!section) return null;
  const { eyebrow, headline = "", subtext = "" } = section;

  // Render *word* fragments as gradient spans. Anything else is plain text.
  const parts = headline.split(/(\*[^*]+\*)/g).filter(Boolean);

  return (
    <div className="flex flex-col gap-6">
      {eyebrow && (
        <span className="text-sm font-medium uppercase tracking-wide text-[#0d5eaf]">
          {eyebrow}
        </span>
      )}
      <h1 className="corp-headline">
        {parts.map((part, i) =>
          part.startsWith("*") && part.endsWith("*") ? (
            <span key={i} className="corp-gradient-text">
              {part.slice(1, -1)}
            </span>
          ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
          )
        )}
      </h1>
      {subtext && <p className="corp-headline-sub">{subtext}</p>}
    </div>
  );
};

export default Hero;
